import React from 'react';
import Icon from '../Icon';
import './styles.css';

/**
 * A propriedade "style" pode receber:
 * "white" : Texto branco
 * "orange": Texto laranja
 * "black": Texto preto
 * "muted": Texto cinza
 *
 * Complemento do ícone
 * "icon": botão com ícone
 */

export const Button = ({
  onClick,
  type = 'button',
  color,
  large,
  noBorder,
  transparent,
  disabled,
  className,
  icon,
  iconImg,
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={disabled}
      onClick={(e) => (onClick ? onClick(e) : undefined)}
      className={`${className} btn ${color || 'white'} ${
        transparent ? 'transparent' : ''
      } ${noBorder ? 'noBorder' : ''} ${large ? 'large' : ''}`}
      type={type}
    >
      {iconImg ? <img src={iconImg} alt="btn-icon" className="me-3" /> : ''}
      {icon ? <Icon path={icon} /> : ''}
      <span>{props.children}</span>
    </button>
  );
};
